import { QUIZ_MODAL_STYLES } from '../../../../../constants/quizModalStyles';

export default () => ({
  ...QUIZ_MODAL_STYLES,
});
